import React, { useState, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";

import { motion, AnimatePresence } from "framer-motion";
import _ from "lodash";
import axios from "axios";

import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import DebugOverlay from "../components/widgets/DebugOverlay";
import NotificationWidget from "../components/widgets/NotificationWidget";
import DataGrid from "../components/cardlibrary/DataGrid";
import NonLegalCardsDataGrid from "../components/cardlibrary/NonLegalCardsDataGrid";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Checkbox from "@mui/material/Checkbox";
import { DataGrid as MuiDataGrid, GridToolbar } from "@mui/x-data-grid";

import Wrapper from "../components/layout/Wrapper";

//HOOKS
import useCardHandler from "../hooks/useCardHandler";
import { SocketContext } from "../context/socket";

const SERVER_URL = window.location.protocol + "//" + window.location.host;

const modalStyle = {
   position: "absolute",
   top: "50%",
   left: "50%",
   transform: "translate(-50%, -50%)",
   width: "95%",
   maxWidth: "1600px",
   height: "85%",
   bgcolor: "background.paper",
   border: "2px solid #000",
   boxShadow: 24,
   p: 4,
   display: "flex",
   flexDirection: "column",
};

function groupBy(objectArray, property) {
   return objectArray.reduce((acc, obj) => {
      const key = obj[property];
      if (!acc[key]) {
         acc[key] = [];
      }
      // Add object to list for given key's value
      acc[key].push(obj);
      return acc;
   }, {});
}

function TabPanel(props) {
   const { children, value, index, ...other } = props;

   return (
      <div
         role="tabpanel"
         hidden={value !== index}
         id={`cardlibrary-tabpanel-${index}`}
         aria-labelledby={`cardlibrary-tab-${index}`}
         {...other}
      >
         {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
      </div>
   );
}

function a11yProps(index) {
   return {
      id: `cardlibrary-tab-${index}`,
      "aria-controls": `cardlibrary-tabpanel-${index}`,
   };
}

export default function CardLibrary() {
   const socket = useContext(SocketContext);
   const [open, setOpen] = React.useState(false);
   const [manageModalOpen, setManageModalOpen] = React.useState(false);
   const [cardSets, setCardSets] = useState();
   const [activeSet, setActiveSet] = useState();
   const [tabValue, setTabValue] = useState(0);
   const [allCardImages, setAllCardImages] = useState([]);
   const [nonLegalCards, setNonLegalCards] = useState([]);

   const handleOpen = () => setOpen(true);
   const handleClose = () => {
      setPreviewCard();
      setOpen(false);
   };

   const handleManageModalOpen = () => setManageModalOpen(true);
   const handleManageModalClose = () => {
      setManageModalOpen(false);
      // Refresh non-legal cards after closing
      fetchNonLegalCards();
   };

   const [previewCard, setPreviewCard] = useState();

   // USE HOOK
   const [allCards, notification, { getAllCards }] = useCardHandler();

   useEffect(() => {
      getAllCards();
   }, []);

   useEffect(() => {
      // Fetch allCardImages when component mounts
      socket.emit("getAllCardImages", (response) => {
         setAllCardImages(response || []);
      });
   }, [socket]);

   const fetchNonLegalCards = () => {
      socket.emit("getAllNonLegalCards", (response) => {
         setNonLegalCards(response || []);
      });
   };

   useEffect(() => {
      // Fetch non-legal cards when component mounts
      fetchNonLegalCards();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [socket]);

   const handleToggleNonLegalCard = (card) => {
      const isNonLegal = nonLegalCards.some(
         (nlc) => nlc.name === card.name && nlc.set === card.set
      );

      if (isNonLegal) {
         // Remove from non-legal cards
         const nonLegalCard = nonLegalCards.find(
            (nlc) => nlc.name === card.name && nlc.set === card.set
         );
         if (nonLegalCard && nonLegalCard.id) {
            socket.emit("removeNonLegalCard", nonLegalCard.id, (response) => {
               fetchNonLegalCards();
            });
         }
      } else {
         // Add to non-legal cards
         socket.emit("addNonLegalCard", card.name, card.set, (response) => {
            fetchNonLegalCards();
         });
      }
   };

   const handleRemoveNonLegalCard = (card) => {
      if (card && card.id) {
         socket.emit("removeNonLegalCard", card.id, (response) => {
            fetchNonLegalCards();
         });
      }
   };

   const handleTabChange = (event, newValue) => {
      setTabValue(newValue);
   };

   useEffect(() => {
      if (allCards) {
         const setGroups = groupBy(
            _.orderBy(allCards, ["SetName"], ["asc"]),
            "Set"
         );

         setCardSets(setGroups);
      }
   }, [allCards]);

   useEffect(() => {
      if (cardSets) {
         // console.log(cardSets);
      }
   }, [cardSets]);

   useEffect(() => {
      if (previewCard) {
         handleOpen();
      }
   }, [previewCard]);

   const handlePreviewCard = (cardId) => {
      let cardInfo = _.find(allCards, { ID: parseInt(cardId) });
      setPreviewCard(cardInfo);
   };

   return (
      <Wrapper>
         <style>
            {`
               .non-legal-row {
                  background-color: #8B0000 !important;
               }
               .non-legal-row:hover {
                  background-color: #A00000 !important;
               }
            `}
         </style>
         <Typography
            variant='h3'
            component='div'
            sx={{ textTransform: "uppercase", mb: 2 }}
         >
            Card Library
         </Typography>

         <Box sx={{ width: "100%", mb: 3 }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
               <Tabs
                  value={tabValue}
                  onChange={handleTabChange}
                  aria-label="card library tabs"
               >
                  <Tab label="ACTIVE CARDS" {...a11yProps(0)} />
                  <Tab label="Iconic Card Library" {...a11yProps(1)} />
               </Tabs>
            </Box>

            <TabPanel value={tabValue} index={0}>
               {allCards && (
                  <>
                     <Typography
                        variant='h4'
                        component='div'
                        sx={{ textTransform: "uppercase", mb: 2 }}
                     >
                        Active Cards in Evoke: {allCards.length}
                     </Typography>

                     <Stack
                        direction='row'
                        sx={{
                           color: "#ccc",
                           width: "100%",
                        }}
                     >
                        <Stack
                           sx={{
                              width: 375,
                              fontSize: ".8em",
                           }}
                        >
                           {Object.entries(
                              _.filter(cardSets, function (set) {
                                 if (set[0].Set == "list") {
                                    return true;
                                 }
                              })
                           ).map(([set, cards]) => (
                              <Button
                                 key={`list-${set}`}
                                 onClick={() =>
                                    activeSet == "list"
                                       ? setActiveSet("")
                                       : setActiveSet("list")
                                 }
                                 variant={activeSet == "list" ? "contained" : "text"}
                                 color={activeSet == "list" ? "warning" : "primary"}
                                 sx={{
                                    borderBottom: "1px solid rgba(255,255,255,.2)",
                                 }}
                              >
                                 <Stack
                                    direction='row'
                                    justifyContent='space-between'
                                    sx={{ width: "100%", textAlign: "left" }}
                                 >
                                    <span>The 'List'</span>
                                    <span>{cards.length}</span>
                                 </Stack>
                              </Button>
                           ))}
                           {cardSets &&
                              Object.entries(cardSets).map(([set, cards]) => (
                                 <React.Fragment key={`set-${set}`}>
                                    {set != "list" && (
                                       <Button
                                          onClick={() =>
                                             activeSet == set
                                                ? setActiveSet("")
                                                : setActiveSet(set)
                                          }
                                          variant={
                                             activeSet == set ? "contained" : "text"
                                          }
                                          color={
                                             activeSet == set ? "warning" : "primary"
                                          }
                                          sx={{
                                             borderBottom:
                                                "1px solid rgba(255,255,255,.2)",
                                          }}
                                       >
                                          <Stack
                                             direction='row'
                                             justifyContent='space-between'
                                             sx={{ width: "100%", textAlign: "left" }}
                                          >
                                             <span>{cards[0].SetName}</span>
                                             <span>{cards.length}</span>
                                          </Stack>
                                       </Button>
                                    )}
                                 </React.Fragment>
                              ))}
                        </Stack>

                        {cardSets && (
                           <Box sx={{ width: "100%" }}>
                              <Box
                                 sx={{
                                    position: "fixed",
                                    width: "calc(100% - 640px)",
                                    pl: 2,
                                 }}
                              >
                                 <DataGrid
                                    key={"datagrid"}
                                    height={"70vh"}
                                    data={activeSet ? cardSets[activeSet] : allCards}
                                    type='cardOverview'
                                    preview={handlePreviewCard}
                                 />
                              </Box>
                           </Box>
                        )}
                     </Stack>
                  </>
               )}
            </TabPanel>

            <TabPanel value={tabValue} index={1}>
               <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                  <Typography
                     variant='h4'
                     component='div'
                     sx={{ textTransform: "uppercase" }}
                  >
                     Iconic Card Library: {nonLegalCards.length}
                  </Typography>
                  <Button
                     variant="contained"
                     color="primary"
                     onClick={handleManageModalOpen}
                  >
                     Manage Iconic Card Library
                  </Button>
               </Stack>
               <Box sx={{ width: "100%" }}>
                  <NonLegalCardsDataGrid
                     data={nonLegalCards}
                     height={"70vh"}
                     onRemove={handleRemoveNonLegalCard}
                  />
               </Box>
            </TabPanel>
         </Box>

         <NotificationWidget notification={notification} />

         {previewCard && (
            <Modal open={open} onClose={handleClose}>
               <Box sx={modalStyle}>
                  <Typography
                     variant='h4'
                     component='h4'
                     sx={{ color: "#333" }}
                  >
                     Card Preview
                     <Button
                        onClick={handleClose}
                        variant='outlined'
                        sx={{ float: "right" }}
                     >
                        Close
                     </Button>
                  </Typography>
                  <Typography sx={{ mt: 6 }}>
                     <Stack direction='row' spacing={8} sx={{ mt: 3 }}>
                        <Box>
                           <img
                              src={
                                 SERVER_URL +
                                 "/cardimages/png/" +
                                 encodeURIComponent(previewCard.FileName) +
                                 ".png"
                              }
                              style={{ maxWidth: 400, pointerEvents: "all" }}
                           />
                        </Box>

                        <Table>
                           <TableBody>
                              {Object.entries(previewCard).map(
                                 ([key, val], i) => (
                                    <React.Fragment key={"data" + i}>
                                       {key !== "legalities" && (
                                          <TableRow key={"datarow-" + i}>
                                             <TableCell
                                                sx={{
                                                   fontWeight: "bold",
                                                   backgroundColor: "#ccc",
                                                   borderBottom:
                                                      "1px solid #fff",
                                                   width: 200,
                                                }}
                                             >
                                                {key}
                                             </TableCell>
                                             <TableCell>{val}</TableCell>
                                          </TableRow>
                                       )}
                                    </React.Fragment>
                                 )
                              )}
                           </TableBody>
                        </Table>
                     </Stack>
                  </Typography>
               </Box>
            </Modal>
         )}

         {/* Manage Non-Legal Cards Modal */}
         <Modal open={manageModalOpen} onClose={handleManageModalClose}>
            <Box sx={modalStyle}>
               <Typography
                  variant='h4'
                  component='h4'
                  sx={{ color: "#333", mb: 3 }}
               >
                  Manage Iconic Card Library
                  <Button
                     onClick={handleManageModalClose}
                     variant='outlined'
                     sx={{ float: "right" }}
                  >
                     Close
                  </Button>
               </Typography>
               <Box sx={{ display: "flex", gap: 2, flex: 1, overflow: "hidden" }}>
                  {/* Left Column - Current Iconic Card Library */}
                  <Box sx={{ width: "30%", display: "flex", flexDirection: "column" }}>
                     <Typography
                        variant='h6'
                        component='div'
                        sx={{ color: "#333", mb: 2, fontWeight: "bold" }}
                     >
                        Current Iconic Card Library ({nonLegalCards.length})
                     </Typography>
                     <Box sx={{ flex: 1, overflowY: "auto", border: "1px solid #ccc", p: 1, backgroundColor: "#f5f5f5" }}>
                        {nonLegalCards.length === 0 ? (
                           <Typography sx={{ color: "#666", textAlign: "center", mt: 2 }}>
                              No cards in Iconic Card Library
                           </Typography>
                        ) : (
                           <Stack spacing={0.5}>
                              {nonLegalCards.map((card, index) => (
                                 <Box
                                    key={`iconic-${card.id || index}`}
                                    sx={{
                                       display: "flex",
                                       alignItems: "center",
                                       gap: 1,
                                       p: 1,
                                       backgroundColor: "#fff",
                                       border: "1px solid #ddd",
                                       borderRadius: 1,
                                       "&:hover": {
                                          backgroundColor: "#f0f0f0",
                                       },
                                    }}
                                 >
                                    <Typography
                                       variant='body2'
                                       sx={{
                                          fontWeight: "bold",
                                          flex: 1,
                                       }}
                                    >
                                       {card.name}
                                    </Typography>
                                    <Typography variant='caption' sx={{ color: "#666" }}>
                                       {card.set}
                                    </Typography>
                                 </Box>
                              ))}
                           </Stack>
                        )}
                     </Box>
                  </Box>

                  {/* Right Column - All Cards Grid */}
                  <Box sx={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
                     <Typography
                        variant='h6'
                        component='div'
                        sx={{ color: "#333", mb: 2, fontWeight: "bold" }}
                     >
                        All Cards
                     </Typography>
                     <Box sx={{ flex: 1, overflow: "hidden" }}>
                        <MuiDataGrid
                           getRowId={(row) => `${row.set}_${row.name}`}
                           sx={{ backgroundColor: "#efefef" }}
                           rows={allCardImages.map((card) => ({
                              ...card,
                              id: `${card.set}_${card.name}`,
                              isNonLegal: nonLegalCards.some(
                                 (nlc) => nlc.name === card.name && nlc.set === card.set
                              ),
                           }))}
                           rowHeight={120}
                           getRowClassName={(params) => {
                              return params.row.isNonLegal ? "non-legal-row" : "";
                           }}
                           columns={[
                              {
                                 field: "checkbox",
                                 headerName: "Active",
                                 width: 100,
                                 filterable: false,
                                 sortable: false,
                                 renderCell: (params) => (
                                    <Checkbox
                                       checked={params.row.isNonLegal}
                                       onChange={(e) => {
                                          e.stopPropagation();
                                          handleToggleNonLegalCard(params.row);
                                       }}
                                       onClick={(e) => e.stopPropagation()}
                                       color="primary"
                                    />
                                 ),
                              },
                              {
                                 field: "image",
                                 headerName: "Image",
                                 width: 120,
                                 filterable: false,
                                 renderCell: (params) => {
                                    const fileName = `${(params.row.set || '').toUpperCase()}_${params.row.name}`;
                                    return (
                                       <Box
                                          sx={{
                                             height: "100%",
                                             p: 1,
                                             backgroundColor: "#fff",
                                          }}
                                       >
                                          <img
                                             src={
                                                SERVER_URL +
                                                "/cardimages/thumbs/" +
                                                encodeURIComponent(fileName) +
                                                ".jpg"
                                             }
                                             height='100%'
                                             alt={params.row.name}
                                             onError={(e) => {
                                                e.target.src = SERVER_URL + "/images/nocard.png";
                                             }}
                                          />
                                       </Box>
                                    );
                                 },
                              },
                              {
                                 field: "name",
                                 headerName: "Name",
                                 width: 300,
                              },
                              {
                                 field: "set",
                                 headerName: "Set",
                                 width: 150,
                              },
                           ]}
                           rowsPerPageOptions={[100, 200, 300, 1000, 5000]}
                           components={{ Toolbar: GridToolbar }}
                           componentsProps={{
                              toolbar: {
                                 printOptions: {
                                    disableToolbarButton: true,
                                 },
                              },
                           }}
                           disableSelectionOnClick
                           onRowClick={(params) => {
                              handleToggleNonLegalCard(params.row);
                           }}
                           initialState={{
                              sorting: {
                                 sortModel: [{ field: "name", sort: "asc" }],
                              },
                           }}
                        />
                     </Box>
                  </Box>
               </Box>
            </Box>
         </Modal>
      </Wrapper>
   );
}
